import { Periodicity } from 'models/enums/periodicity';
import { IShopDashboardData, IShopDashboardAction } from 'models/shop/dashboard';
import { IStore } from 'redux/IStore';
import * as moment from 'moment';
import * as c from 'models/constants';

/** Action Types */
export const GET_SALES_REQUEST: string = 'shopdashboard/GET_SALES_REQUEST';
export const GET_SALES_SUCCESS: string = 'shopdashboard/GET_SALES_SUCCESS';
export const GET_SALES_FAILURE: string = 'shopdashboard/GET_SALES_FAILURE';
export const GET_SERVICEPOPULARITY_REQUEST: string = 'shopdashboard/GET_SERVICEPOPULARITY_REQUEST';
export const GET_SERVICEPOPULARITY_SUCCESS: string = 'shopdashboard/GET_SERVICEPOPULARITY_SUCCESS';
export const GET_SERVICEPOPULARITY_FAILURE: string = 'shopdashboard/GET_SERVICEPOPULARITY_FAILURE';
export const GET_FOLLOWERS_REQUEST: string = 'shopdashboard/GET_FOLLOWERS_REQUEST';
export const GET_FOLLOWERS_SUCCESS: string = 'shopdashboard/GET_FOLLOWERS_SUCCESS';
export const GET_FOLLOWERS_FAILURE: string = 'shopdashboard/GET_FOLLOWERS_FAILURE';
export const GET_ORDERS_REQUEST: string = 'shopdashboard/GET_ORDERS_REQUEST';
export const GET_ORDERS_SUCCESS: string = 'shopdashboard/GET_ORDERS_SUCCESS';
export const GET_ORDERS_FAILURE: string = 'shopdashboard/GET_ORDERS_FAILURE';
export const GET_PRODUCTS_REQUEST: string = 'shopdashboard/GET_PRODUCTS_REQUEST';
export const GET_PRODUCTS_SUCCESS: string = 'shopdashboard/GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAILURE: string = 'shopdashboard/GET_PRODUCTS_FAILURE';
export const SET_SHOP_ID: string = 'shopdashboard/SET_SHOP_ID';
export const RESET_DATA: string = 'shopdashboard/RESET_DATA';
export const CLEAR_STATISTICS: string = 'shopdashboard/CLEAR_STATISTICS';
export const SET_PERIODICITY: string = 'shopdashboard/SET_PERIODICITY';
export const SET_PERIOD: string = 'shopdashboard/SET_PERIOD';
export const CHANGE_SELECTED_TAB: string = 'shopdashboard/CHANGE_SELECTED_TAB';

/** Initial State */
const initialState: IShopDashboardData = {
	isFetching: false,
	isFetchingFollowers: false,
	isFetchingOrders: false,
	isFetchingProducts: false,
	sales: [],
	servicePopularity: [],
	orders: [],
	products: [],
	followers: [],
	selectedPeriodicity: Periodicity.Week,
	dateFrom: moment().startOf('isoWeek').toISOString(),
	dateTo: new Date('1989-07-29').toISOString(),
	selectedProductsTab: c.SHOPDASHBOARD_TAB_MOSTSOLD,
	productsTabsNamespace: c.SHOPDASHBOARD_PRODUCTTABS_NAMESPACE,
};

/** Reducer */
export function shopDashboardReducer(state = initialState, action: IShopDashboardAction) {
	switch (action.type) {
		case GET_SALES_REQUEST:
			return Object.assign({}, state, {
				isFetching: true,
			});

		case GET_SALES_SUCCESS:
			return Object.assign({}, state, {
				sales: action.payload.sales,
				isFetching: false,
			});

		case GET_SALES_FAILURE:
			return Object.assign({}, state, {
				message: action.payload.message,
				error: true,
			});

		case GET_SERVICEPOPULARITY_REQUEST:
			return Object.assign({}, state, {
				isFetching: true,
			});

		case GET_SERVICEPOPULARITY_SUCCESS:
			return Object.assign({}, state, {
				servicePopularity: action.payload.servicePopularity,
				isFetching: false,
			});

		case GET_SERVICEPOPULARITY_FAILURE:
			return Object.assign({}, state, {
				message: action.payload.message,
				error: true,
			});

		case GET_FOLLOWERS_REQUEST:
			return Object.assign({}, state, {
				isFetchingFollowers: true,
			});

		case GET_FOLLOWERS_SUCCESS:
			return Object.assign({}, state, {
				followers: action.payload.followers,
				isFetchingFollowers: false,
			});

		case GET_FOLLOWERS_FAILURE:
			return Object.assign({}, state, {
				message: action.payload.message,
				error: true,
			});

		case GET_ORDERS_REQUEST:
			return Object.assign({}, state, {
				isFetchingOrders: true,
			});

		case GET_ORDERS_SUCCESS:
			return Object.assign({}, state, {
				orders: action.payload.orders,
				isFetchingOrders: false,
			});

		case GET_ORDERS_FAILURE:
			return Object.assign({}, state, {
				message: action.payload.message,
				error: true,
			});

		case GET_PRODUCTS_REQUEST:
			return Object.assign({}, state, {
				isFetchingProducts: true,
			});

		case GET_PRODUCTS_SUCCESS:
			return Object.assign({}, state, {
				products: action.payload.products,
				isFetchingProducts: false,
			});

		case GET_PRODUCTS_FAILURE:
			return Object.assign({}, state, {
				message: action.payload.message,
				error: true,
			});

		case SET_SHOP_ID:
			return Object.assign({}, state, {
				shopId: action.payload.shopId,
			});

		case SET_PERIODICITY:
			return Object.assign({}, state, {
				selectedPeriodicity: action.payload.selectedPeriodicity,
			});

		case SET_PERIOD:
			return Object.assign({}, state, {
				dateFrom: action.payload.dateFrom,
				dateTo: action.payload.dateTo,
			});

		case RESET_DATA:
			return Object.assign({}, state, initialState);

		case CLEAR_STATISTICS:
			return Object.assign({}, state, {
				sales: [],
				followers: [],
			});

		case CHANGE_SELECTED_TAB:
			return Object.assign({}, state, {
				selectedProductsTab: action.payload.selectedProductsTab,
				products: action.payload.products,
			});

		default:
			return state;
	}
}

// /** Action Creator */
export function getSales(shopId: string, officeId?: string, shouldSetDate: boolean = true) {
	return (dispatch, getState: () => IStore) => {
		dispatch(salesRequest());

		const shopDashboard = getState().shopDashboard;
		let queryString = '?';
		if (shouldSetDate && shopDashboard.dateFrom && shopDashboard.dateTo) {
			queryString = queryString + '&dateFrom=' + shopDashboard.dateFrom + '&dateTo=' + shopDashboard.dateTo;
		}
		if (officeId) {
			queryString = queryString + '&officeId=' + officeId;
		}
		return fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/' + shopId + '/Sales/' + queryString,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: any) => {
						dispatch(salesSuccess(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(salesFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(salesFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(salesFailure(err));
			});
	};
}

/**
 *
 * @param shopId
 * @param officeId
 * @returns data of the top 10 most booked bookingTemplates (name, sku, times booked, revenue)
 */
export function getBookingTemplatesPopularity(shopId: string, officeId?: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(servicePopularityRequest());

		const shopDashboard = getState().shopDashboard;
		const queryOfficeId = officeId && officeId !== 'all' ? officeId : '';

		const params = new URLSearchParams({
			dateFrom: shopDashboard.dateFrom,
			dateTo: shopDashboard.dateTo,
			officeId: queryOfficeId,
		});

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/' + shopId + '/BookingTemplatesPopularity/?' + params,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: any) => {
						dispatch(servicePopularitySuccess(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(servicePopularityFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(servicePopularityFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(servicePopularityFailure(err));
			});
	};
}

// /** Action Creator */
export function getFollowers(shopId: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(followersRequest());

		const shopDashboard = getState().shopDashboard;
		const queryString = '?dateFrom=' + shopDashboard.dateFrom + '&dateTo=' + shopDashboard.dateTo;

		return fetch(
			getState().fetchDefault.baseAPI + 'api/shop/' + shopId + '/Followers' + queryString,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: any) => {
						dispatch(followersSuccess(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(followersFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(followersFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(followersFailure(err));
			});
	};
}

/** Action Creator */
export function getShopOrders(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(ordersRequest());

		let queryString = '?';
		queryString = queryString + '&currentPage=' + 1;
		queryString = queryString + '&itemsPerPage=' + 10;
		queryString = queryString + '&headerOnly=true';
		queryString = queryString + '&sortColumn=AddedDate DESC';

		return fetch(
			getState().fetchDefault.baseAPI + 'api/order/GetByShop/' + id + queryString,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						dispatch(ordersSuccess(res.items));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(ordersFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(ordersFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(ordersFailure(err));
			});
	};
}

/** Action Creator */
export function getProducts(id: string, action: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(productsRequest());

		const shopDashboard = getState().shopDashboard;
		let queryString = '?';
		queryString = queryString + '&shopid=' + id;
		queryString = queryString + '&dateFrom=' + shopDashboard.dateFrom;
		queryString = queryString + '&dateTo=' + shopDashboard.dateTo;

		return fetch(
			getState().fetchDefault.baseAPI + 'api/product/' + action + '/' + queryString,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						dispatch(productsSuccess(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(productsFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(productsFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(productsFailure(err));
			});
	};
}

/** Action Creator */
export function changeTabAndGetRequiredData(selectedTab: string, shopId: string) {
	return (dispatch) => {
		dispatch(changeSelectedProductsTab(selectedTab));

		switch (selectedTab) {
			case c.SHOPDASHBOARD_TAB_MOSTSOLD:
				dispatch(getProducts(shopId, 'MostSold'));
				break;

			case c.SHOPDASHBOARD_TAB_MOSTLIKED:
				dispatch(getProducts(shopId, 'MostLiked'));
				break;

			case c.SHOPDASHBOARD_TAB_MOSTWISHLISTED:
				dispatch(getProducts(shopId, 'MostWishlisted'));
				break;

			default:
				break;
		}
	};
}

/** Action Creator */
export function setPeriodicity(periodicity: Periodicity, page: 'dashboard' | 'analytics') {
	return (dispatch, getState: () => IStore) => {
		// Don't clear for analytics for now as the sales are always loaded for AllTime
		if (page === 'dashboard') {
			dispatch(clearStatistics());
		}
		dispatch(setPeriodicityData(periodicity));

		switch (periodicity) {
			case Periodicity.Week:
				dispatch(setPeriod(moment().startOf('isoWeek').toISOString(), moment().endOf('isoWeek').toISOString()));
				break;

			case Periodicity.Month:
				dispatch(setPeriod(moment().startOf('month').toISOString(), moment().endOf('month').toISOString()));
				break;

			case Periodicity.Year:
				dispatch(setPeriod(moment().startOf('year').toISOString(), moment().endOf('year').toISOString()));
				break;

			case Periodicity.AllTime:
				dispatch(setPeriod('', ''));
				break;

			default:
				dispatch(setPeriod(moment().startOf('isoWeek').toISOString(), moment().endOf('isoWeek').toISOString()));
		}
		if (page === 'dashboard') {
			const shopDashboard = getState().shopDashboard;
			dispatch(getSales(shopDashboard.shopId));
			dispatch(getFollowers(shopDashboard.shopId));
			dispatch(changeTabAndGetRequiredData(shopDashboard.selectedProductsTab, shopDashboard.shopId));
		}
	};
}

export function setPeriodBackwards() {
	return (dispatch, getState: () => IStore) => {
		dispatch(clearStatistics());
		const shopDashboard = getState().shopDashboard;
		const periodicity = shopDashboard.selectedPeriodicity;
		const dateFrom = shopDashboard.dateFrom;
		const dateTo = shopDashboard.dateTo;

		if (periodicity !== Periodicity.AllTime) {
			dispatch(
				setPeriod(
					getPeriodDate(new Date(dateFrom), periodicity, true).toISOString(),
					getPeriodDate(new Date(dateTo), periodicity, true).toISOString(),
				),
			);
			dispatch(getSales(shopDashboard.shopId));
			dispatch(getFollowers(shopDashboard.shopId));
			dispatch(changeTabAndGetRequiredData(shopDashboard.selectedProductsTab, shopDashboard.shopId));
		}
	};
}

export function setPeriodForward() {
	return (dispatch, getState: () => IStore) => {
		dispatch(clearStatistics());
		const shopDashboard = getState().shopDashboard;
		const periodicity = shopDashboard.selectedPeriodicity;
		const dateFrom = shopDashboard.dateFrom;
		const dateTo = shopDashboard.dateTo;

		if (periodicity !== Periodicity.AllTime) {
			dispatch(
				setPeriod(
					getPeriodDate(new Date(dateFrom), periodicity, false).toISOString(),
					getPeriodDate(new Date(dateTo), periodicity, false).toISOString(),
				),
			);
			dispatch(getSales(shopDashboard.shopId));
			dispatch(getFollowers(shopDashboard.shopId));
			dispatch(changeTabAndGetRequiredData(shopDashboard.selectedProductsTab, shopDashboard.shopId));
		}
	};
}

// for given date get new date based on periodicity and info about moving period backward or forward
function getPeriodDate(date: Date, periodicity: Periodicity, goBack: boolean): Date {
	switch (periodicity) {
		case Periodicity.Week:
			return goBack ? moment(date).subtract(1, 'weeks').toDate() : moment(date).add(1, 'weeks').toDate();

		case Periodicity.Month:
			return goBack ? moment(date).subtract(1, 'months').toDate() : moment(date).add(1, 'months').toDate();

		case Periodicity.Year:
			return goBack ? moment(date).subtract(1, 'years').toDate() : moment(date).add(1, 'years').toDate();

		default:
			return goBack ? moment(date).subtract(1, 'weeks').toDate() : moment(date).add(1, 'weeks').toDate();
	}
}

// /** Action Creator */
export function salesRequest(): IShopDashboardAction {
	return {
		type: GET_SALES_REQUEST,
	};
}

/** Action Creator */
export function salesSuccess(sales: []): IShopDashboardAction {
	return {
		type: GET_SALES_SUCCESS,
		payload: {
			sales,
		},
	};
}

// /** Action Creator */
export function salesFailure(message: any): IShopDashboardAction {
	return {
		type: GET_SALES_FAILURE,
		payload: {
			message,
		},
	};
}

// /** Action Creator */
export function servicePopularityRequest(): IShopDashboardAction {
	return {
		type: GET_SERVICEPOPULARITY_REQUEST,
	};
}

/** Action Creator */
export function servicePopularitySuccess(servicePopularity: []): IShopDashboardAction {
	return {
		type: GET_SERVICEPOPULARITY_SUCCESS,
		payload: {
			servicePopularity,
		},
	};
}

// /** Action Creator */
export function servicePopularityFailure(message: any): IShopDashboardAction {
	return {
		type: GET_SERVICEPOPULARITY_FAILURE,
		payload: {
			message,
		},
	};
}

// /** Action Creator */
export function followersRequest(): IShopDashboardAction {
	return {
		type: GET_FOLLOWERS_REQUEST,
	};
}

/** Action Creator */
export function followersSuccess(followers: []): IShopDashboardAction {
	return {
		type: GET_FOLLOWERS_SUCCESS,
		payload: {
			followers,
		},
	};
}

// /** Action Creator */
export function followersFailure(message: any): IShopDashboardAction {
	return {
		type: GET_FOLLOWERS_FAILURE,
		payload: {
			message,
		},
	};
}

// /** Action Creator */
export function ordersRequest(): IShopDashboardAction {
	return {
		type: GET_ORDERS_REQUEST,
	};
}

/** Action Creator */
export function ordersSuccess(orders: []): IShopDashboardAction {
	return {
		type: GET_ORDERS_SUCCESS,
		payload: {
			orders,
		},
	};
}

// /** Action Creator */
export function ordersFailure(message: any): IShopDashboardAction {
	return {
		type: GET_ORDERS_FAILURE,
		payload: {
			message,
		},
	};
}

// /** Action Creator */
export function productsRequest(): IShopDashboardAction {
	return {
		type: GET_PRODUCTS_REQUEST,
	};
}

/** Action Creator */
export function productsSuccess(products: []): IShopDashboardAction {
	return {
		type: GET_PRODUCTS_SUCCESS,
		payload: {
			products,
		},
	};
}

// /** Action Creator */
export function productsFailure(message: any): IShopDashboardAction {
	return {
		type: GET_PRODUCTS_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function setShopId(shopId: string): IShopDashboardAction {
	return {
		type: SET_SHOP_ID,
		payload: {
			shopId,
		},
	};
}

/** Action Creator */
export function setPeriodicityData(selectedPeriodicity: Periodicity): IShopDashboardAction {
	return {
		type: SET_PERIODICITY,
		payload: {
			selectedPeriodicity,
		},
	};
}

export function setPeriod(dateFrom: string, dateTo: string): IShopDashboardAction {
	return {
		type: SET_PERIOD,
		payload: {
			dateFrom,
			dateTo,
		},
	};
}

/** Action Creator */
export function resetData(): IShopDashboardAction {
	return {
		type: RESET_DATA,
	};
}

/** Action Creator */
export function clearStatistics(): IShopDashboardAction {
	return {
		type: CLEAR_STATISTICS,
	};
}

/** Action Creator */
export function changeSelectedProductsTab(selectedProductsTab: string): IShopDashboardAction {
	return {
		type: CHANGE_SELECTED_TAB,
		payload: {
			selectedProductsTab,
			products: [],
		},
	};
}
